module.exports = __webpack_public_path__ + "static/img/post-bg.b6c97648.png";